import { styled, theme } from '@components-shared/src/stitches';
import { Skeleton } from '@components/main-components/skeleton/Skeleton';

const TOP_HEIGHT = 32;

export const Card = styled('div', {
  width: '100%',
  height: '88px',
  display: 'flex',
  background: '#fff',
  borderRadius: 8,
  lift: 'tertiary',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  variants: {
    unclaimed: {
      true: {
        cursor: 'unset',
        opacity: 0.5,
        '@laptop': {
          width: '100%',
        },
      },
    },

    expandedSection: {
      true: {
        width: '100%',
        maxWidth: '100%',
      },
    },
  },
});

export const LeftContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: 56,
});

export const Top = styled('div', {
  width: '100%',
  display: 'flex',
  alignItems: 'center',

  div: {
    height: TOP_HEIGHT,
    display: 'flex',
    alignItems: 'center',
  },

  variants: {
    borderRight: {
      true: {
        borderRight: '1px solid $neutral200',
      },
    },
  },
});

export const UnclaimedTop = styled(Top, {
  height: TOP_HEIGHT,
  flexShrink: 0,
});

export const Rank = styled('div', {
  marginX: 'auto',
  fontFamily: '$title',
  color: '$neutral700',
  fontSize: '16px',
  fontWeight: '500',
  lineHeight: '19.2px',
});

export const Name = styled('h1', {
  position: 'relative',
  base: 'L',
  lineHeight: '19.2px',
  color: '$neutral900',
  fontWeight: '600',
  marginLeft: 8,
  cursor: 'pointer',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: 120,
  '@tablet': {
    maxWidth: 160,
  },
  '@laptop': {
    maxWidth: 128,
  },
  '@desktop': {
    maxWidth: 170,
  },
  variants: {
    unclaimed: {
      true: {
        fontWeight: '400',
        color: '$neutral400',
      },
    },
    seeAllPage: {
      true: {
        maxWidth: 200,
        '@tablet': {
          maxWidth: 120,
        },
        '@desktop': {
          maxWidth: 140,
        },
      },
    },
  },
});

export const RightContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  base: 'M',
  color: '$neutral500',
  lineHeight: '14px',
  width: '100%',
  variants: {
    expandedSection: {
      true: {
        '@desktop': {
          maxWidth: 164,
        },
      },
    },
  },
});

export const InfoContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  borderTop: '1px solid $neutral200',
  div: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginLeft: 8,
  },
});

export const Fade = styled('div', {
  position: 'absolute',
  backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0) 100%)',
  height: '100%',
  width: '225px',
  pointerEvents: 'none',

  variants: {
    position: {
      end: {
        height: 32,
        width: 48,
        backgroundImage: theme.gradients.white,
        borderRadius: '0 8px 0 0',
        transform: 'translateX(112px)',
        '@laptop': {
          width: 68,
          transform: 'translateX(100px)',
        },
      },
    },
  },
});

export const CollectorCardSkeleton = styled(Skeleton, {
  height: 88,
  borderRadius: 8,
  width: '100%',
});
